import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/pro-solid-svg-icons';

import Text from './text';

class Link extends React.Component {
  static propTypes = {
    onOverrideReset: PropTypes.func.isRequired
  }

  render() {
    return (
      <Text
        {...this.props}
        renderHeader={this.renderHeader}
      />
    );
  }

  renderHeader = (active, hasOverride) => {
    if (!active) {
      return null;
    }

    return (
      <div className="control header" key="header">
        {this.renderResetButton(hasOverride)}
        <span className="link-preview" name="link-preview">
          Preview Link
        </span>
      </div>
    );
  }

  renderResetButton(hasOverride) {
    if (!hasOverride) {
      return null;
    }

    return (
      <React.Fragment>
        <span className="click-target" name="reset" onClick={this.props.onOverrideReset}>
          <FontAwesomeIcon icon={faUndo} />
          Reset
        </span>
        <span>|</span>
      </React.Fragment>
    );
  }
}

export default Link;
